module.exports = __webpack_public_path__ + "static/img/老板小黑翼D1 超薄顶侧双吸烟灶套装.43328a88.png";